/**
 * Vendor Bundle Entry Point
 *
 * Bundles all third-party libraries into a single vendor.min.js file
 * to reduce HTTP requests and improve page load performance.
 */

// jQuery - Load and expose globally
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

// What Input - Tracks input method (mouse, keyboard, touch)
import whatInput from 'what-input';
window.whatInput = whatInput;

// Foundation Sites - UI framework
import Foundation from 'foundation-sites';
window.Foundation = Foundation;

// Highcharts - Data visualization
// In Highcharts 12.x, modules auto-register when imported
import Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/solid-gauge';

// Expose Highcharts globally
window.Highcharts = Highcharts;

// Legacy clock timer - Import from legacy folder
// Note: This file needs to be available and will be bundled
import './legacy/w3fclocktimer.js';
